import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class GoogleLoginService {

  constructor(
    private http: HttpClient
  ) { }

  googleLogin(data: any) {
    return this.http.post(`${environment.baseUrl}/user/v1/login`, data);
  }

  listUserById(id: any) {
    return this.http.get(`${environment.baseUrl}/user/v1/get-user/${id}`);
  }

  logout(data: any) {
    return this.http.post(`${environment.baseUrl}/user/v1/logout`, data);
  }
  signUp(data:any){
    return this.http.post(`${environment.baseUrl}/user/v1/sign-up`, data);
  }
}
